import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import * as React from "react";

export interface IReportsProps {}

export function Reports(props: IReportsProps) {
	return (
		<div>
			<PageHead pageTitle="Reports" pageHead="Reports"></PageHead>
		</div>
	);
}
